module.exports = __webpack_public_path__ + "static/media/IAM.bf575910.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IAM.svg
// module id = 626
// module chunks = 0